module.exports = __webpack_public_path__ + "static/media/V-img7.d2f5c1b2.png";